import { NavigationProp } from '@react-navigation/native'
import { RootStore } from '../../data/store'
import { Routes } from '../../nav/routes'
import { ENABLE_REPORT_DOWNLOADS_IN_MOBILE, isOsMobile } from '../../util/util'
import { JioLogo } from './CustomHeader'
import { RightContainer } from './RightContainer'
import { TimerComp } from './TimerComp'

export const closerMarginIcon = (screenName: string, navigation: NavigationProp, handlePress: any) => {
  let iconName = ''
  let onPress = () => {}
  switch (screenName) {
    case Routes.TRANSACTIONS:
      iconName = 'FILTER'
      onPress = handlePress
      break
    case Routes.QR_CODE:
      iconName = ''
      break
    case Routes.PROFILE:
      iconName = ''
      break

    default:
      break
  }
  return { iconName, onPress }
}

export const rightToMarginIcon = (screenName: string, navigation: NavigationProp) => {
  let iconName = ''
  let onPress = () => console.log('ssa')
  switch (screenName) {
    case Routes.HOME:
      iconName = 'SEARCH'
      onPress = () => navigation?.navigate('search')
      break
    case Routes.TRANSACTIONS:
      iconName = 'SEARCH'
      onPress = () => navigation?.navigate('search')
      break
    case Routes.REFUNDS:
      iconName = 'SEARCH'
      onPress = () => navigation?.navigate('search')
      break
    case Routes.SETTLEMENTS:
      iconName = 'SEARCH'
      onPress = () => navigation?.navigate('search')
      break
    case Routes.QR_CODE:
      iconName = ''
      break
    case Routes.PROFILE:
      iconName = ''
      break

    default:
      break
  }
  return { iconName, onPress }
}

export function titleCase(str: string) {
  var splitStr = str?.split(' ')
  for (var i = 0; i < splitStr?.length; i++) {
    splitStr[i] = splitStr[i]?.charAt(0)?.toUpperCase() + splitStr[i]?.substring(1)
  }
  return splitStr.join(' ')
}

export const getLeftHeaderInTabNavigator = (tabIndex: number) => {
  switch (tabIndex ?? 1) {
    case 0:
      return <JioLogo />
    default:
      return
  }
}

interface rightHeaderPartInterface {
  indexMapper: number
  timer: number
  filterData: () => any
  showTimer: boolean
}

export const getRightHeaderInTabNavigator = ({
  indexMapper,
  timer,
  filterData,
  showTimer,
}: rightHeaderPartInterface) => {
  const showQr = isOsMobile()
  const isSearchAvailable = RootStore.userManagement.isSearchBarVisible() ?? false

  const getHeaderComp: any = {
    true: <TimerComp timer={timer} showTimer={showTimer} />,
    false: isSearchAvailable && <RightContainer leftComp={'search'} />,
  }

  switch (indexMapper) {
    case 0:
      return isSearchAvailable && <RightContainer leftComp={'search'} />
    case 1:
      return (
        <RightContainer
          leftComp={'filter'}
          filterData={filterData}
          rightComp={isSearchAvailable ? 'search' : undefined}
          shouldShowDownloadButtonTab={ENABLE_REPORT_DOWNLOADS_IN_MOBILE}
          index={1}
        />
      )

    case 2:
      return getHeaderComp[String(showQr)]
    case 3:
      return (
        <RightContainer
          leftComp={isSearchAvailable ? 'search' : undefined}
          shouldShowDownloadButtonTab={ENABLE_REPORT_DOWNLOADS_IN_MOBILE}
          index={3}
        />
      )

    default:
      return
  }
}
